"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.urlDomain = void 0;
var urlDomain = function (url) {
  var matches = url.match(/^(?:https?:)?(?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n]+)/im);
  if (matches && matches.length === 2) {
    return matches[1];
  }
  return url;
};
exports.urlDomain = urlDomain;